'use client';

import { c } from '../../utils/tailwind-merge';
import { PackageList } from '../PackageList/PackageList';
import { ProductOverview } from '../ProductOverview/ProductOverview';
import { ReleaseList } from '../ReleaseList/ReleaseList';
import { SheetsStack } from '../Sheets/SheetsStack';
import { TabsContent, TabsList, TabsRoot, TabsTrigger } from '../Tabs/Tabs';
import { ProductTabsProps } from './types';

export const ProductTabs = ({
  microcopy,
  overview,
  packages,
  releases,
  onOpenInUnity,
  className = '',
}: ProductTabsProps) => {
  const mobileSheetDataWrapper = [
    {
      label: microcopy.overview,
      microcopy: { close: microcopy.close },
      children: <ProductOverview {...overview} />,
    },
    {
      label: microcopy.packages,
      microcopy: { close: microcopy.close },
      children: <PackageList {...packages} onOpenInUnity={onOpenInUnity} />,
    },
    {
      label: microcopy.releases,
      microcopy: { close: microcopy.close },
      children: <ReleaseList {...releases} />,
    },
  ];

  return (
    <section className={c('w-full', className)}>
      <section className="hidden md:block">
        <TabsRoot defaultValue="overview">
          <TabsList>
            <TabsTrigger value="overview">{microcopy.overview}</TabsTrigger>
            <TabsTrigger value="packages">{microcopy.packages}</TabsTrigger>
            <TabsTrigger value="releases">{microcopy.releases}</TabsTrigger>
          </TabsList>

          <TabsContent value="overview">
            <ProductOverview {...overview} />
          </TabsContent>
          <TabsContent value="packages">
            <PackageList {...packages} onOpenInUnity={onOpenInUnity} />
          </TabsContent>
          <TabsContent value="releases">
            <ReleaseList {...releases} />
          </TabsContent>
        </TabsRoot>
      </section>

      <section className="block md:hidden">
        <SheetsStack sheets={mobileSheetDataWrapper} className="pt-0" />
      </section>
    </section>
  );
};
